import { Autocomplete, Box, TextField, Tooltip, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { getOrgTokens } from "../../theme/style/organizationPalette";

const SelectBox = ({ Icon, label, placeholder = "", value, onChange, disabled = false, options, disableClearable = false, freeSolo = true, tooltip, sx = {}, width = "100%" }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const tok = getOrgTokens(isDark);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, width: width, ...sx }}>
      {label && (
        <Box sx={{ display: "flex", gap: 0.75 }}>
          {Icon && <Icon size={16} style={{ color: theme.palette.text.navigation, marginTop: "auto", marginBottom: "auto" }} />}
          <Box sx={{ display: label ? "block" : "none" }}>
            <Tooltip title={t(tooltip || "")} arrow placement="right">
              <Typography variant="Textbox Label">{t(label)}</Typography>
            </Tooltip>
          </Box>
        </Box>
      )}
      <Box>
        <Autocomplete
          options={options}
          //   getOptionLabel={(option) => option.label || option}
          value={t(options.find((o) => o.value === value)?.label) || value}
          onChange={onChange}
          disabled={disabled}
          isOptionEqualToValue={(option, value) => (typeof value === "string" ? option.value === value : option.value === value.value)}
          disableClearable={disableClearable}
          freeSolo={freeSolo}
          sx={{
            width: "100%",
            "& .MuiAutocomplete-popupIndicator": { color: "#4b5563" },
            "& .MuiAutocomplete-clearIndicator": {
              // color: theme.palette.text.textbox_label,
              color: "#4b5563",
            },
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder={t(placeholder)}
              sx={{
                "& .MuiInputBase-root": {
                  fontFamily: "Poppins",
                  fontSize: 14,
                  height: 40,
                  display: "flex",
                  alignItems: "center",
                  borderRadius: "12px",
                  "& .MuiInputBase-input": {
                    paddingY: 0,
                  },
                },
                "& .MuiOutlinedInput-root": {
                  height: 40,
                  borderRadius: "12px",
                  paddingRight: "35px !important",
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: tok.border.divider,
                    borderWidth: 1,
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#16a34a",
                  },
                  "&.Mui-focused": {
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#16a34a",
                      borderWidth: "2px",
                    },
                  },
                },
              }}
            // slotProps={{ input: { readOnly: true } }}
            />
          )}
          slotProps={{
            listbox: {
              sx: {
                fontFamily: "Poppins",
                "& .MuiAutocomplete-option": {
                  fontFamily: "Poppins",
                  fontSize: 14,
                  "&:hover": { backgroundColor: "rgba(23, 163, 74, 0.2)" },
                },
              },
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default SelectBox;
